import { useEffect } from "react";

export const useScrollLock = (lock: boolean) => {
  useEffect(() => {
    document.body.style.overflow = lock ? "hidden" : "unset";
  }, [lock]);
};
